export const isOwner = (user) => user?.role === "owner";
